import { DEFAULT_TABLE_PAGE_SIZE } from 'src/constants/Pagination';
import { JobConfigPageState } from './types';

export const initialState: JobConfigPageState = {
  isLoading: true,
  tableData: [],
  filteredTableData: [],
  currentPage: 1,
  perPage: DEFAULT_TABLE_PAGE_SIZE,
  totalPages: 0,
  searchField: '',
  createdJobSuccessfully: false,
  isJobConfigTableFilterSheetOpen: false,
  jobConfigTableFilterOptions: {
    jobNames: [],
    regions: [],
    types: [],
    siteTypes: [],
    isActiveSelections: [],
  },
  jobConfigTableFilter: {
    jobNames: [],
    regions: [],
    types: [],
    siteTypes: [],
    isActiveSelections: [],
  },
  jobConfigTableFilterTags: [],
};
